import { useContext } from 'react';
import QffUserContext from './QffUserContext';

const useQffUser = () => useContext(QffUserContext);

export default useQffUser;
